module.exports = __webpack_public_path__ + "static/media/pen-edit-icon.68b80ddf.svg";